import script from "./NovelDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./NovelDetail.vue?vue&type=script&setup=true&lang=js"

import "./NovelDetail.vue?vue&type=style&index=0&id=97381ae2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97381ae2"]])

export default __exports__